(function() {
  'use strict';

  angular
    .module('quiz.labelingPicture', [])
    .controller('LabelingPictureCtrl', LabelingPictureCtrl);

  LabelingPictureCtrl.$inject = ['$scope', '$timeout', '$window'];

  function LabelingPictureCtrl($scope, $timeout, $window) {
    // eslint-disable-next-line consistent-this
    var vm = this;
    var originalAnswers = [];
    var amtImages = 0;

    vm.hasAnswer = false;
    vm.data = [];
    vm.onAnswerDroppedOnImage = onAnswerDroppedOnImage;
    vm.getLpAnsweredLabelStyle = getLpAnsweredLabelStyle;
    vm.getAnswerLabel = getAnswerLabel;
    vm.onUpdate = onUpdate;

    $scope.$watch('state.answerGraded', onDragState);
    $scope.$watch('state.answerSubmitted', onDragState);
    $scope.$watch('state.tryAgainRequested', onTryAgainRequested);
    $scope.$watch('state.showAnswersRequested', onShowAnswersRequested);
    $scope.$watch('question.correctAnswer', setup);

    function setup() {
      var answeredQuestions;

      $scope.loaded = false;
      $scope.questionAnswers = noNulls($scope.questionAnswers, 'text');
      $scope.questionImages = noNulls($scope.questionImages);

      vm.hasAnswer = $scope.currentSlide.hasAnswer;

      // answered previously
      if (vm.hasAnswer && ($scope.question.selectedAnswer || []).length > 0) {
        // the server sends back the answers which are not actually attached to anything
        originalAnswers = noNulls($scope.question.selectedAnswer).slice(0, $scope.questionImages.length);
      } else {
        originalAnswers = _.pluck($scope.questionAnswers, 'text');
      }

      $scope.images = _.map($scope.questionImages, function(image, index) {
        return {
          index: index,
          image: image,
          imageSrc: image.editedImageFileLocation
        };
      });

      answeredQuestions = mapAnswers();

      // eslint-disable-next-line no-negated-condition
      if (!vm.randomizedImages) {
        if (vm.hasAnswer || $scope.state.answerSubmitted) {
          vm.randomizedImages = $scope.images.concat();
        } else {
          orderImages();
        }
      } else {
        updateRandomizedImages();
      }

      vm.getAssociatedImageId = function(answer) {
        return answer.image ? 'image-answer-' + answer.image.index : '';
      };

      amtImages = $scope.questionImages.length;

      if (amtImages < 4) {
        $scope.labelPictureVerticalAlign = 'top: 30%;';
      }

      $scope.state.answerSelected = answeredQuestions === amtImages;
      $scope.loaded = true;

      $timeout(function() {
        // need to trigger the labels to reposition
        angular.element($window).trigger('resize');
      });
    }

    function mapAnswers() {
      var answeredQuestions = 0;
      var imageIdx;
      var image;

      vm.answers = _.map(originalAnswers, function(text, index) {
        var ret = {
          text: text
        };

        // associate image
        if ($scope.answer.selectedAnswer) {
          imageIdx = $scope.answer.selectedAnswer.indexOf(text);
          image = $scope.images[imageIdx];
          if (image) {
            ret.image = image;

            // apply grading - these are the indexes of the images which have correct answers
            if ($scope.question.correctAnswer) {
              ret.isCorrect = $scope.question.correctAnswer.indexOf(imageIdx) !== -1;
            }

            answeredQuestions++;
          }
        }

        return ret;
      });

      return answeredQuestions;
    }

    function orderImages() {
      var originalImages;
      var resultImages;
      var imageIdxsAdded;
      var order = $scope.quizAnswerStorage.getLabelingImagesOrder($scope.question.id);

      if (!order) {
        randomizeImages();
        return;
      }

      originalImages = $scope.images.slice(0);
      resultImages = [];
      imageIdxsAdded = [];

      _.each(order.order, function(index) {
        resultImages.push(_.find(originalImages, function(item) {
          if (item.index === index) {
            imageIdxsAdded.push(index);
            return true;
          }
          return false;
        }));
      });

      // if the trainer added new images to this question
      if (imageIdxsAdded.length < originalImages.length) {
        _.each(originalImages, function(item, index) {
          if (imageIdxsAdded.indexOf(index) !== -1) {
            return;
          }

          resultImages.push(item);
        });
      }

      vm.randomizedImages = resultImages;
    }

    function randomizeImages() {
      var resultImages = _.shuffle($scope.images.concat());
      var order = _.pluck(resultImages, 'index');

      $scope.quizAnswerStorage.setLabelingImagesOrder($scope.question.id, order);
      vm.randomizedImages = resultImages;
    }

    function updateRandomizedImages() {
      _.each(vm.randomizedImages, function(item) {
        var image = $scope.images[item.index];
        item.isCorrect = image.isCorrect;
        item.answerIdx = image.answerIdx;
        item.answer = image.answer;
      });
    }

    function setSelectedAnswers() {
      var answeredQuestions = 0;

      // put the labels of the answers in the order of the images to support our midtier
      $scope.answer.selectedAnswer = new Array(6);

      _.each(vm.answers, function(answer) {
        if (answer.image) {
          answeredQuestions++;
          $scope.answer.selectedAnswer[answer.image.index] = answer.text;
        }
      });

      $scope.state.answerSelected = answeredQuestions === amtImages;
      $scope.storeSelectedAnswer();
    }

    function onAnswerDroppedOnImage(image, answer) {
      if (image) {
        // remove any previously-paired answer
        _.each(vm.answers, function(ans) {
          if (ans.image && ans.image.index === image.index) {
            ans.image = null;
          }
        });
      }

      $timeout(function() {
        answer.image = image;
        setSelectedAnswers();
      });
    }

    function getLpAnsweredLabelStyle(answer) {
      if ($scope.state.showAnswersRequested) {
        return $scope.question.partialCorrect ? 'review-partial-correct' : 'review-no-partial-correct';
      } else if ($scope.state.answerGraded) {
        if ($scope.state.answerSubmitted && $scope.question.partialCorrect) {
          return answer.isCorrect ? 'correct' : 'incorrect';
        }
      }

      return '';
    }

    function getAnswerLabel(answer) {
      if (!answer) {
        return;
      }

      return getLpAnsweredLabelStyle(findAnswerByText(answer));
    }

    function onUpdate(image, answer) {
      var lookupAnswer;
      var duplicateAnswerIdx;

      // answer is select answer
      if (answer === '') {
        vm.data[image.index] = undefined;
        onAnswerDroppedOnImage(null, findAnswerByImage(image));
        return;
      }

      lookupAnswer = findAnswerByText(answer);
      duplicateAnswerIdx = findIndexOfDuplicateAnswer(answer, image.index);

      if (duplicateAnswerIdx > -1) {
        vm.data[duplicateAnswerIdx] = undefined;
      }

      onAnswerDroppedOnImage(image, lookupAnswer);
    }

    function findAnswerByImage(value) {
      return _.find(vm.answers, function(ans) {
        return ans.image === value;
      });
    }

    function findAnswerByText(value) {
      return _.find(vm.answers, function(ans) {
        return ans.text === value;
      });
    }

    function findIndexOfDuplicateAnswer(answer, index) {
      return _.findIndex(vm.data, function(ans, idx) {
        return ans === answer && idx !== index;
      });
    }

    function onDragState() {
      vm.dragDisabled = $scope.state.answerGraded || $scope.state.answerSubmittedlabelPictureVerticalAlign;
    }

    function onTryAgainRequested(newValue) {
      if (!newValue) {
        return;
      }

      vm.hasAnswer = false;
      vm.answers = arrayPick($scope.questionAnswers, 'text');
      $scope.currentSlide.numPoints = 0;
      $scope.answer.selectedAnswer = [];
      vm.data = [];

      randomizeImages();
      updateRandomizedImages();
    }

    function onShowAnswersRequested(newValue) {
      if (!newValue) {
        mapAnswers();
      } else if ($scope.question.correctAnswerList) {
        _.each(vm.answers, function(answer) {
          // change the text of the label to what it is supposed to be
          answer.text = $scope.question.correctAnswerList[answer.image.index];
        });
      }
    }

    function noNulls(arr, property) {
      var ret = [];
      var i = 0;
      var len = arr.length;

      if (!property) {
        for (; i < len; i++) {
          // eslint-disable-next-line no-eq-null, eqeqeq
          if (arr[i] != null) {
            ret.push(arr[i]);
          }
        }
        return ret;
      }

      for (; i < len; i++) {
        // eslint-disable-next-line no-eq-null, eqeqeq
        if (arr[i][property] != null) {
          ret.push(arr[i]);
        }
      }
      return ret;
    }

    function arrayPick(arr, p) {
      var props = _.rest(arguments, 1);
      return _.map(arr, function(i) {
        return _.pick.apply(null, [i].concat(props));
      });
    }
  }
})();
